import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

const searchSchema = z.object({
  filter: z.enum(['active', 'archived']).catch('active').default('active'),
})

export const Route = createFileRoute(
  '/_app/$workspace/_dashboard/implementations/',
)({
  validateSearch: searchSchema,
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/$workspace/tasks',
      params,
      search,
      replace: true,
    })
  },
})
